import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class List extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const array = [];
        let list = [];

        content.forEach((item, index) => {
            if (index % 2 === 0) {
                list.push(
                    <h2 key={index} className={styles.title}>
                        {item.children && item.children.length > 0 ? (
                            <React.Fragment>
                                <a href={item.url} target="_blank" title={item.title}>
                                    {item.title}
                                </a>
                                {item.children.map((child, index) => (
                                    <React.Fragment key={index}>
                                        <a href={child.url} target="_blank" title={child.title}>
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a href={item.url} target="_blank" title={item.title}>
                                {item.title}
                            </a>
                        )}
                    </h2>,
                );
            } else {
                list.push(
                    <p key={index} className={styles.text}>
                        {item.children && item.children.length > 0 ? (
                            <React.Fragment>
                                <a href={item.url} target="_blank" title={item.title}>
                                    {item.title}
                                </a>
                                {item.children.map((child, index) => (
                                    <React.Fragment key={index}>
                                        <a href={child.url} target="_blank" title={child.title}>
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a href={item.url} target="_blank" title={item.title}>
                                {item.title}
                            </a>
                        )}
                    </p>,
                );
                array.push(
                    <div key={index} className={styles.hot}>
                        {list}
                    </div>,
                );
                list = [];
            }
        });

        return <div style={{ position: 'relative' }}>{array}</div>;
    }
}

export default errorBoundary(List);
